export default __webpack_public_path__ + "static/media/warmup_revision.9bff7383.png";